import { render } from "./RsvpListComponent.vue?vue&type=template&id=c50945c4&scoped=true"
import script from "./RsvpListComponent.vue?vue&type=script&lang=js"
export * from "./RsvpListComponent.vue?vue&type=script&lang=js"

import "./RsvpListComponent.vue?vue&type=style&index=0&id=c50945c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50945c4"]])

export default __exports__